import React, { Component, Fragment } from 'react';
import { View } from 'react-native';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Creators as pedidosActions } from '../../store/ducks/pedidos';
import { Creators as pedidoSelecionadoActions } from '../../store/ducks/pedido-selecionado';

import ListaPedido from '../../components/listaPedido';
import PedidoDetalhe from '../../components/pedidoDetalhe';

import styles from './styles';

class ListaPedidoWrapper extends Component {
    componentDidUpdate(prevProps) {
        const data = this.props.pedidos?.list?.data ?? [];
        const prevData = prevProps.pedidos?.list?.data ?? [];
        const first = data[0] || {};
        const prevFirst = prevData[0] || {};
        const { idPedido } = this.props.pedidoSelecionado || {};

        if (first.idPedido !== prevFirst.idPedido || !idPedido) {
            setTimeout(() => this.syncPedidoSelection(), 200);
        }
    }

    syncPedidoSelection = () => {
        const { pedidos, pedidoSelecionado, selectPedido, deselectPedido } = this.props;
        const data = pedidos?.list?.data ?? [];
        const selectedId = pedidoSelecionado?.idPedido;

        if (data.length === 0) {
            if (selectedId) deselectPedido();
            return;
        }

        const isSelectedInList = selectedId && data.some((p) => p.idPedido === selectedId);
        if (isSelectedInList) return;

        selectPedido(data[0]);
    };

    renderDesktop = () => {
        const {
                navigation,
                idStatusPedido,
                showItemActions,
                idStatusList,
                pedidoSelecionado,
                showOrderCounter,
                isHistorico = false
            } = this.props,
            { idPedido } = pedidoSelecionado;

        return (
            <View style={styles.container}>
                <View style={styles.content}>
                    <View style={styles.list}>
                        <ListaPedido
                            isHistorico={isHistorico}
                            onSelect={this.onSelect}
                            idStatusPedido={idStatusPedido}
                            showOrderCounter={showOrderCounter}
                        />
                    </View>

                    <View style={styles.detail}>
                        <PedidoDetalhe
                            idPedido={idPedido}
                            isHistorico={isHistorico}
                            navigation={navigation}
                            showItemActions={showItemActions}
                            idStatusPedido={idStatusPedido}
                            idStatusList={idStatusList}
                        />
                    </View>
                </View>
            </View>
        );
    };

    render() {
        return <Fragment>{this.renderDesktop()}</Fragment>;
    }
}

const mapStateToProps = ({ pedidoSelecionado, pedidos }) => ({
    pedidoSelecionado,
    pedidos
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        { ...pedidoSelecionadoActions, ...pedidosActions },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ListaPedidoWrapper);